<template>
  <router-link class="item" :to="{ name: 'course.show', params: { id: course.id, slug: course.slug } }">
    <picture>
        <img width="120" :src="course.thumb" />
      </picture>
      <div>
        <h5 class="item__name">{{ course.name }}</h5>
        <div  class="item__author">Por: {{ course.authors_name }}</div>
      </div>
  </router-link>
</template>

<script>
  export default {
    props: {
      course: { type: Object, required: true }
    }
  }
</script>

<style lang="scss" scoped>
  @import "~@/assets/sass/variables";

  .item {
    display: flex;
    align-items: center;
    padding: 16px;
    border: 1px solid $white10;
    border-radius: 8px;
    background: $purple700;

    &:not(:last-child) { 
      margin-bottom: 10px 
    }

    &:hover {
      border: 1px solid $purple800;
      background: $purple800;
      color: $textPrimaryColor;
    }

    picture { 
      margin-right: 10px 
    }

    img { 
      width: 82.286px;
      border-radius: 5px
    }

    &__name { 
      font-size: 1.1rem;
    }

    &__author { 
      color: $white100;
      font-size: 0.89rem;
    }
  }
</style>